
export default function BookingLoading() {
    return (
  
  
      <div className="d-flex justify-content-center px-5  mb-5 bg-white">
      <div className="boxes mt-5 pt-5  mb-5">
      <div className="box">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
      </div>
      <div className="box">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
      </div>
      <div className="box">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
      </div>
      <div className="box">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
      </div>
  </div>
      </div>
    );
  }
  